/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { Checkbox as MaterialUICheckbox } from '@material-ui/core'

export default function Checkbox(props) {
  return (
    <MaterialUICheckbox {...props} />
  )
}
